import React, { useEffect, useState } from 'react';
import ApexCharts from 'react-apexcharts';
import axios from 'axios';
import { BANTUAN_TOTAL_PER_TAHUN, API_TIMEOUT } from '../../utils';
import { Spinner } from 'reactstrap';
import s from './GrafikDanaTahunan.module.scss';

const formatRupiah = (n) =>
  new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(n || 0);

const GrafikDanaTahunan = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(BANTUAN_TOTAL_PER_TAHUN, { timeout: API_TIMEOUT })
      .then((res) => {
        const raw = res.data?.data || [];
        setData(Array.isArray(raw) ? raw : []);
      })
      .catch(() => setData([]))
      .finally(() => setLoading(false));
  }, []);

  const labels = data.map((d) => String(d.tahun));
  const values = data.map((d) => Number(d.totalDana) || 0);

  const options = {
    chart: {
      type: 'bar',
      toolbar: { show: false },
      fontFamily: 'Poppins, sans-serif',
    },
    plotOptions: {
      bar: {
        borderRadius: 8,
        columnWidth: '60%',
        dataLabels: { position: 'top' },
      },
    },
    dataLabels: {
      enabled: true,
      formatter: (val) => (val >= 1000000000 ? `${(val / 1000000000).toFixed(1)} Milyard` : val >= 1000000 ? `${(val / 1000000).toFixed(0)} Juta` : val),
      offsetY: -20,
      style: { fontSize: '11px', colors: ['#000000'] },
    },
    stroke: { show: true, width: 2, colors: ['transparent'] },
    xaxis: {
      categories: labels,
      labels: { style: { fontSize: '12px', colors: ['#000000'] } },
    },
    yaxis: {
      labels: {
        style: { colors: ['#000000'] },
        formatter: (val) =>
          val >= 1000000000
            ? `${(val / 1000000000).toFixed(1)} Milyard`
            : val >= 1000000
            ? `${(val / 1000000).toFixed(0)} Juta`
            : val >= 1000
            ? `${(val / 1000).toFixed(0)} Ribu`
            : val,
      },
    },
    fill: {
      type: 'gradient',
      gradient: {
        shade: 'light',
        type: 'vertical',
        shadeIntensity: 0.3,
        gradientToColors: ['#4d53e0'],
        opacityFrom: 0.85,
        opacityTo: 0.6,
      },
    },
    colors: ['#4d53e0'],
    tooltip: {
      y: {
        formatter: (val) => formatRupiah(val),
      },
    },
    legend: {
      labels: {
        colors: ['#000000'],
      },
    },
    grid: {
      borderColor: '#e8e8e8',
      strokeDashArray: 4,
      xaxis: { lines: { show: false } },
    },
  };

  const series = [{ name: 'Total Dana Bantuan', data: values }];

  if (loading) {
    return (
      <div className={s.loadingWrap}>
        <Spinner color="primary" />
        <p className={s.loadingText}>Memuat grafik...</p>
      </div>
    );
  }

  if (!data.length) {
    return (
      <div className={s.emptyWrap}>
        <i className="eva eva-pie-chart-outline" />
        <p>Belum ada data total dana per tahun</p>
      </div>
    );
  }

  return (
    <div className={s.grafikWrap}>
      <h6 className={s.chartTitle}>Total Dana Bantuan per Tahun (2018 - {new Date().getFullYear()})</h6>
      <ApexCharts
        options={options}
        series={series}
        type="bar"
        height={360}
      />
    </div>
  );
};

export default GrafikDanaTahunan;
